import { formatEther } from "viem";
import { ELYSIUM, sameIdentity } from "../../../config/elysium";
import type { NftView, HistoricalMintFee } from "../types";

export function nftMintFee(nft: Pick<NftView, "mintFeeWei" | "collectionAddress">): string {
  if (nft.mintFeeWei == null) return "Unknown";
  if (nft.mintFeeWei === "0") return "Free";
  return `${formatEther(BigInt(nft.mintFeeWei))} ${sameIdentity(nft.collectionAddress, ELYSIUM.collection) ? "HYPE" : "ETH"}`;
}

/** Merge display fee only; callers retain the original chain detail for actions. */
export function detailMintFee(nft: NftView, inventory: NftView | null,
  history: HistoricalMintFee | undefined, chainId: number | null | undefined): { label: string; saved: boolean } {
  if (chainId !== ELYSIUM.chainId || nft.chainId !== chainId) return { label: nftMintFee(nft), saved: false };
  const matches = (candidate: HistoricalMintFee | NftView) => candidate.chainId === chainId &&
    candidate.tokenId === nft.tokenId && sameIdentity(candidate.collectionAddress, nft.collectionAddress) &&
    sameIdentity(candidate.sourceToken, nft.sourceToken) &&
    !(candidate.mintTxHash && nft.mintTxHash && !sameIdentity(candidate.mintTxHash, nft.mintTxHash));
  if (history && matches(history)) {
    // Conflicting retained mint evidence cannot establish this fee's provenance.
    if (inventory && matches(inventory) && inventory.mintTxHash && history.mintTxHash &&
      !sameIdentity(inventory.mintTxHash, history.mintTxHash)) return { label: "Unknown", saved: false };
    return { label: nftMintFee(history), saved: false }; // Valid null/missing from BE means Unknown, not a fallback.
  }
  if (inventory && matches(inventory)) return { label: nftMintFee(inventory), saved: true };
  return { label: nftMintFee(nft), saved: false };
}
